const variables = {
  bgColorMain: '#080508',
  colorMain: '#f3dea0',
  colorSub: '#fced95',
  cdnURL: 'https://assets.17app.co/golden_feather/result/',
  tablet: 1024,
  mobile: 767,
  mobile320: 325,
};

module.exports = {
  properties: {
    variables: variables,
  },
  variables: {
    variables: variables,
  },
  media: {
    extensions: {
      '--tablet': '(max-width: ' + variables.tablet + 'px)',
      '--mobile': '(max-width: ' + variables.mobile + 'px)',
      '--mobile320': '(max-width: ' + variables.mobile320 + 'px)',
    },
  },
};



//////////////////
// WEBPACK FOOTER
// ./config/postcss.config.js
// module id = 40
// module chunks = 0